import { Language } from "../domain/Language";
import { translitEnabled, translitLang } from "../SystemState";
import { addKeyboardBinding } from "../util/ui/Keyboard";
import { setupCustomCheckbox } from "./CustomCheckbox";
export function setupToolbar() {
    const checkbox = setupCustomCheckbox("translitEnabledToggle", "translitEnabledCheckmark");
    checkbox.checked = translitEnabled.value;
    checkbox.onchange = () => translitEnabled.value = checkbox.checked;
    const select = document.getElementById("langSelect");
    Language.values
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
        .forEach(lang => select.appendChild(new Option(lang.displayName, lang.shortName)));
    select.value = translitLang.value.shortName;
    select.onchange = () => translitLang.value = Language.getByShortName(select.value);
    addKeyboardBinding({ code: "Escape" }, () => checkbox.click());
    addKeyboardBinding({ code: "KeyL", shortKey: true }, () => select.focus());
}
